import React from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import {
  FormSection,
  ShouldUpdateWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import { useOptions } from 'helper/hooks';
import ListSection from '../ListSection';

const CriminalRecord = ({ className, isEdit, form, data }) => {
  const { scTypeOfViolationOptions } = useOptions();
  return (
    <ListSection
      className={className}
      isEdit={isEdit}
      form={form}
      data={data['criminal_records'] || []}
      title="Criminal Record"
      addBtnText="Add Record"
      parentName="criminal_records"
      fields={[
        {
          label: 'Type of Violation',
          key: 'type_of_violation',
          type: 'value',
        },
        {
          label: 'Year',
          key: 'year',
          type: 'value',
        },
        {
          label: 'Other',
          key: 'other',
          type: 'value',
          // display base on condition
          dependField: 'type_of_violation',
          dependFn: val => val !== 'Other',
        },
      ]}
      renderEditForm={index => {
        return (
          <FormSection>
            <InputItem
              name={[index, 'type_of_violation_id']}
              label="Type of Violation"
              form={form}
              type="select"
              options={scTypeOfViolationOptions}
            />
            <InputItem
              name={[index, 'year']}
              label="Year"
              form={form}
              placeholder="Enter year"
              addressGroupField
            />
            <InputItem
              name={[index, 'fake']}
              label="Fake"
              form={form}
              addressGroupField
              fake
            />
            <ShouldUpdateWrapper>
              {() => {
                const values = form.getFieldsValue();
                const valueObj =
                  get(values, `criminal_records[${index}]`) || {};
                const foundType =
                  find(scTypeOfViolationOptions, {
                    value: valueObj.type_of_violation_id,
                  }) || {};
                if (foundType.label !== 'Other') {
                  return <></>;
                }
                return (
                  <>
                    <InputItem
                      name={[index, 'other']}
                      label="Other"
                      form={form}
                    />
                  </>
                );
              }}
            </ShouldUpdateWrapper>
          </FormSection>
        );
      }}
    />
  );
};

export default CriminalRecord;
